import $ from "jquery"
import {bindActionCreators} from "redux";
import DropdownTemplateView from "../../../DropdownTemplateView"
import WorkflowStatusFilterMenu from './WorkflowStatusFilterMenu'
import {getWorkflowStatusesArray} from "../../../entities/selectors"
import {connect} from "../../../redux/utils";
import {applyTaskStatusFilterAction} from "../../../taskManagement/common/actions";
import {getMenuStatusFilter} from './selectors'
import {setStatusFilter, resetFilter} from './actions'

class TaskWorkflowStatusFilterMenu extends DropdownTemplateView {
    constructor({
        applyFilter = (filter) => {},
        resetFilter = () => {},
        setMenuStatusFilter = () => {},
    }) {
        super();
        this.props = {
            applyFilter,
            resetFilter,
            setMenuStatusFilter,
        }
        this.state = {
            filter: {
                allSelected: false,
                statusIds: [],
                statusTypes: [],
            },
            statuses: [],
        };

        this.onAnyStatePropertyChanged(['filter', 'statuses'], () => {
            this._updateFilter()
        });

    }

    templateHtml() {
        return "<div class='dropdownContainer taskWorkflowStatusFilterMenu_taskManagement'>" +
               " <div class='taskStatusSelection'></div>" +
               "  <div class='buttons'>" +
               "    <div class='apply components_button'><%-apply%></div>" +
               "    <div class='cancel components_button'><%-cancel%></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        this.statusFilter = new WorkflowStatusFilterMenu({
            onChangeSelection: this._handleChangeFilter
        }).init(this.find(".taskStatusSelection"));
        this.find(".apply").on("click", () => {
            this.props.applyFilter(this.state.filter);
            this.hide();
        });
        this.find(".cancel").on("click", () => this.hide())
    }

    _handleChangeFilter = (newFilter) => {
        this.props.setMenuStatusFilter(newFilter)
    }

    messageKeys() {
        return {
            apply: "workflow_filter_menu.apply_button",
            cancel: "workflow_filter_menu.cancle_button"
        };
    }

    showAt($element, positionParams, onHideCb = () => {}) {
        this.props.resetFilter()
        super.showAt($element, positionParams);
        this.onHideCb = onHideCb;
    }

    onShow() {
        super.onShow()
        this.statusFilter.update()
    }

    onHide() {
        super.onHide()
        this.onHideCb()
    }

    _updateFilter() {
        const filter = this.state.filter;
        this.statusFilter.setState({
            allSelected: filter.allSelected,
            selectionState: {
                statusIds: filter.statusIds,
                statusTypes: filter.statusTypes,
            },
            statuses:  this.state.statuses,
        });
    }
}

let instance = null
export const getInstance = () => {
    if (!instance) {
        instance = new TaskWorkflowStatusFilterMenuConnected({}).init($("body"))
    }
    return instance
}

const TaskWorkflowStatusFilterMenuConnected = connect(
    state => ({
        filter: getMenuStatusFilter(state),
        statuses: getWorkflowStatusesArray(state),
    }),
    dispatch => ({
        applyFilter: bindActionCreators(applyTaskStatusFilterAction, dispatch),
        resetFilter: bindActionCreators(resetFilter, dispatch),
        setMenuStatusFilter: bindActionCreators(setStatusFilter, dispatch)
    })
)(TaskWorkflowStatusFilterMenu)



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/TaskWorkflowStatusFilterMenu.js